import React, { useState } from 'react';
import { Box, IconButton, Menu, MenuItem } from '@material-ui/core';
import StoryApprovalModal from './StoryApprovalModal';
import moment from 'moment';
import {
  getCommonOneApprovalAsync,
  getStoryDetailsAsync,
} from '../ApprovalStore/approvalSlice';
import { useDispatch } from 'react-redux';
import { APPROVAL_UPDATE_STORY_ROUTE } from '../../../routes/routes';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import MoreVertIcon from '@material-ui/icons/MoreVert';

export const STORY_TABLE_COLUMNS = [
  { Header: 'Entity Type', accessor: 'entityType' },
  { Header: 'Approval Type', accessor: 'approvalType' },
  { Header: 'New value', accessor: 'newValue' },
  {
    Header: 'Status',
    accessor: 'status',
  },
  {
    Header: 'Created at',
    accessor: 'createdAt',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { createdAt } = payload;
      return (
        <>
          <Box>{moment(createdAt).format('MMMM Do, YYYY')}</Box>
        </>
      );
    },
  },
  {
    Header: 'Action',
    accessor: '',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const dispatch = useDispatch();
      const [openModal, setOpenModal] = useState(false);
      return (
        <>
          <StoryApprovalModal
            open={openModal}
            onClose={() => {
              setOpenModal(false);
            }}
          />
          <Box
            onClick={() => {
              setOpenModal(true);
              dispatch(getCommonOneApprovalAsync({ _id: payload._id }));
              dispatch(getStoryDetailsAsync({ entityId: payload.entityId }));
            }}
            sx={{ cursor: 'pointer', textDecoration: 'underline' }}>
            View Details
          </Box>
        </>
      );
    },
  },
];

export const EDITORIAL_STORY_TABLE_COLUMNS = [
  { Header: 'Title', accessor: 'title' },
  { Header: 'Submitted By', accessor: 'submittedBy' },
  { Header: 'Type', accessor: 'type' },
  {
    Header: 'Status',
    accessor: 'articleStatus',
  },
  {
    Header: 'Created at',
    accessor: 'createdAt',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { createdAt } = payload;
      return (
        <>
          <Box>{moment(createdAt).format('MMMM Do, YYYY')}</Box>
        </>
      );
    },
  },
  {
    Header: 'Action',
    accessor: '',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const [anchorEl, setAnchorEl] = useState(null);
      const [openModal, setOpenModal] = useState(false);

      const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };

      const handleClose = () => {
        setAnchorEl(null);
      };

      const open = Boolean(anchorEl);
      return (
        <>
          <StoryApprovalModal
            data={payload && payload}
            open={openModal}
            onClose={() => {
              setOpenModal(false);
            }}
          />
          <Box width={80} fontSize={14}>
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={handleClick}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
              PaperProps={{
                style: {
                  maxHeight: 48 * 4.5,
                  width: '20ch',
                },
              }}>
              <MenuItem
                onClick={() => {
                  setOpenModal(true);
                }}>
                View Story
              </MenuItem>
              <Link
                style={{ textDecoration: 'none', color: 'black' }}
                to={`${APPROVAL_UPDATE_STORY_ROUTE}?Id=${
                  payload && payload._id
                }`}>
                <MenuItem
                  onClick={() => {
                    setOpenModal(true);
                  }}>
                  Update Story
                </MenuItem>
              </Link>
            </Menu>
          </Box>
        </>
      );
    },
  },
];
